﻿import {useMemo} from "react";
import {Attachments} from "../Attachments";
import {FullAttachmentConfiguration} from "../components/FullCreateAttachmentsComponent";
import IAttachments from "../interfaces/IAttachments";
import {AttachmentRequirements} from "../types/InstallationByHostData";

export default function useEntityAttachments(entity: IAttachments | undefined, requirements: AttachmentRequirements): FullAttachmentConfiguration {
	return useMemo(() => ({
		required: Attachments.findExpiredTypes(entity, requirements.required),
		updatable: Attachments.findSubmitted(entity),
		optional: Attachments.findExpiredTypes(entity, requirements.optional)

	}), [entity, requirements]);
}
